let apiHost =  `//qa.lvyou.test.sankuai.com`
let embedHost = `//qa.lvyou.test.sankuai.com`
let loginHost = '//epassport.sjst.beta.sankuai.com'
let mscHost = '//tpt.dev.sankuai.com'
let assertUrl = '//awp-assets.sankuai.com'
let iHost = '//test.i.meituan.com'
let misSSOUrl = '//develop.sso.test.sankuai.info'
let misApiHost = `//qa.lvyou.test.sankuai.com`
let otpHost = '//qa.3f.meituan.com/old/index.html'
let awpHost = '//test01.awp.sankuai.com'
let falconHost = `//qa.lvyou.test.sankuai.com`;
let directDealApiHost = `//zhilian-product.lvyou.test.sankuai.com`
let webSocketHost = `//notifywpush.trip.st.meituan.com`
switch (ENV) {
    case 'production':
        // 接口地址
        apiHost = '//lvyou.meituan.com'
        otpHost = '//3f.meituan.com/new/index.html'
        awpHost = '//awp.meituan.com';
        // iframe 内嵌旧系统的地址
        embedHost = '//lvyou.meituan.com'
        // 登录登出接口地址
        loginHost = 'https://epassport.meituan.com'
        // iframe 结算的地址
        mscHost = '//tpt.meituan.com'
        // awp静态资源地址
        assertUrl = '//awp-assets.meituan.net'
        // i版预览
        iHost = '//i.meituan.com'
        // mis 登录页
        misSSOUrl = '//sso.sankuai.com'
        misApiHost = '//lvyou.meituan.com'
        falconHost = '//lvyou.meituan.com';
        directDealApiHost = '//product-zhilian.meituan.com'
        webSocketHost = '//notifywpush-platform.meituan.com'
        break
    case 'staging':
        apiHost = '//st.lvyou.meituan.com'
        loginHost = 'https://epassport.meituan.com'
        awpHost = '//st.awp.meituan.com';
        embedHost = '//st.lvyou.meituan.com'
        mscHost = '//tpt.st.sankuai.com'
        assertUrl = '//awp-assets.sankuai.com'
        iHost = '//test.i.meituan.com'
        misSSOUrl = '//sso.sankuai.com'
        misApiHost = '//st.lvyou.meituan.com'
        otpHost = '//st.3f.meituan.com/old/index.html';
        falconHost = '//st.lvyou.meituan.com';
        directDealApiHost = '//zhilian-product.trip.st.sankuai.com'
        webSocketHost = '//notifywpush.trip.st.meituan.com'
        break
    case 'offline':
        otpHost = '//test.3f.meituan.com'
        apiHost = '//lvyou.test.sankuai.info'
        embedHost = '//lvyou.test.sankuai.info'
        mscHost = '//tpt.dev.sankuai.com'
        awpHost = '//test02.awp.sankuai.com';
        break
    case 'qa':
    default:
}
falconHost = falconHost + '/tbms/trip/report/otp';
export { apiHost, embedHost, mscHost, loginHost, assertUrl, iHost, misSSOUrl, misApiHost, otpHost, awpHost, falconHost, directDealApiHost, webSocketHost }



// WEBPACK FOOTER //
// ./src/config/env.conf.js